import { useTranslation } from "react-i18next";
import multiMode from "./filterBaseMulti";
import singleMode from "./filterBaseSingle";

const rawItems = [
	{
		key: "friendship_free",
		value: 1,
		meta: {
			url: "2",
			value: 1,
			for: "friendship_free",
		},
	},
	{
		key: "one_time",
		value: 8,
		meta: {
			url: "256",
			value: 8,
			for: "one_time",
		},
	},
	{
		key: "virtual",
		value: 5,
		meta: {
			url: "32",
			value: 5,
			for: "virtual",
		},
	},
	{
		key: "real_meeting",
		value: 9,
		meta: {
			url: "512",
			value: 9,
			for: "real_meeting",
		},
	},
	{
		key: "sex",
		value: 3,
		meta: {
			url: "8",
			value: 3,
			for: "sex",
		},
	},
	{
		key: "longer_relation",
		value: 0,
		meta: {
			url: "1",
			value: 0,
			for: "longer_relation",
		},
	},
	{
		key: "relationship",
		value: 6,
		meta: {
			url: "64",
			value: 6,
			for: "relationship",
		},
	},
];

export { rawItems };

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.value : null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.url : "";
	},
	searchForUrlToApiData: (value) => {
		if (!value) return null;
		const current = Number(
			rawItems.find(({ meta: { url } }) => url === value)?.value
		);

		return current;
	},
	searchForUrlToKey: (value) => {
		if (!value) return null;
		return rawItems.find(({ meta: { url } }) => url === value)?.key;
	},
};

const useFilterPurpose = ({ initial, multiple, noComponent }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	let items = [];
	if (noComponent) {
		items = rawItems;
	} else {
		items = rawItems.map((item) => ({
			...item,
			content: t(`filtersAndSelectors:purpose.${item.key}`),
		}));
	}
	return {
		rawItems,
		items,
		compute,
		isMultiple: multiple,
		isValid,
		...(multiple
			? multiMode({ items, initial, compute })
			: singleMode({ items, initial, compute })),
	};
};

export default useFilterPurpose;
